"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Init Sentry
const Sentry = require("@sentry/browser");
Sentry.init({
    dsn: 'https://ef7dd43fef87452494e563fd94f224af@o4505408983334912.ingest.sentry.io/4505461353742336',
    allowUrls: [
        /https?:\/\/((cdn|www)\.)?atenzijlstra\.nl/,
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0000001,
    replaysOnErrorSampleRate: 1,
});
